export default class ModalAnotherDocuments extends HTMLDivElement {

    constructor() {
        super();
    }

    connectedCallback() {
        const links = document.querySelectorAll('.another-item');

        for (const link of links) {
            link.addEventListener('click', (e) => {
                e.preventDefault();
                e.stopPropagation();

                window.HegydCore.initRemoteModal(
                    '#modal',
                    '',
                    function(){
                        if(link.dataset.type == 'video') {
                            var content = '<video controls="true" width="100%"><source src="'+link.dataset.url+'" /></video>';
                        }
                        else{
                            //Youtube
                            //On récupère l'id de la vidéo pour la mettre sous un format "embed" lisible en dehors de Youtube
                            const url = link.dataset.url;

                            const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                            const match = url.match(regExp);

                            const videoId = (match && match[2].length === 11) ? match[2] : null;

                            //On dimensionne l'iframe en fonction de la taille de la modal et dans un format 16 9eme
                            //Le + 2 sert à compenser les border d'1px
                            var content = '<iframe width="'+($("#modal .modal-content").width() + 2)+'" height="'+($("#modal .modal-content").width() + 2) * 0.5625+'" src="//www.youtube.com/embed/'+ videoId + '" allowfullscreen></iframe>';
                        }
                        $('#modal .modal-content').html(content);
                    },
                    (data) => {

                    },
                    () => {

                    }
                );
            });
        }
    }

    getId(url) {
        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);

        return (match && match[2].length === 11)
            ? match[2]
            : null;
    }
}